module.exports = __webpack_public_path__ + "img/milk.a0470bbf.png";